import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["field", "output"]

  connect() {
    this.change()
  }

  change(e) {
    if (e) e.preventDefault()
    this.outputTarget.classList.toggle("d-none")
  }
}
